import { InputCurrency } from "@/components/input-currency/InputCurrency";
import { Field, Text } from "@chakra-ui/react";
import { Control, FieldValues } from "react-hook-form";

interface Props {
  label: string;
  fieldName: string;
  control: Control<FieldValues>;
  invalid: boolean;
  errorText?: string;
  disabled?: boolean;
}

export const PriceBoardCurrencyField = ({
  control,
  fieldName,
  invalid,
  label,
  errorText,
  disabled,
}: Props) => {
  return (
    <Field.Root
      invalid={invalid}
      gap="4px"
      data-testid={`price-board-currency-field-${fieldName}`}
    >
      <Field.Label>
        <Text fontSize="16px" fontWeight={600}>
          {label}
        </Text>
      </Field.Label>
      <InputCurrency
        control={control}
        name={fieldName}
        height="40px"
        maxLength={12}
        disabled={disabled}
      />
      <Field.ErrorText>{errorText}</Field.ErrorText>
    </Field.Root>
  );
};
